import { t, getLanguage, translateInLanguage } from "../core/i18n.js";
import { icon } from "./icons.js";

export function guideDemo(topic, language = getLanguage()) {
  const t = (key) => translateInLanguage(key, language);
  if (topic === "daily-planner")
    return `<div class="guide-demo" data-demo="guide-plan" aria-hidden="true"><div class="guide-demo-caption">${icon("today")}<span>${t("Today’s plan")}</span><i></i></div><div class="guide-demo-input"><span data-guide-typing></span><i></i><b data-guide-add>${icon("plus")}</b></div><div class="guide-demo-agenda"><div><small>07:00</small><span>${t("Go for a run")}</span>${icon("check")}</div><div><small>09:00</small><span>${t("Focus on important work")}</span>${icon("check")}</div><div class="guide-new-plan"><small>18:00</small><span>${t("Learn something new")}</span>${icon("check")}</div></div></div>`;
  if (topic === "plan-tracker")
    return `<div class="guide-demo" data-demo="guide-track" aria-hidden="true"><div class="guide-demo-caption">${icon("check")}<span>${t("Small steps add up.")}</span><i></i></div><div class="guide-tracking"><div class="guide-progress-ring"><svg viewBox="0 0 100 100"><circle cx="50" cy="50" r="43"/><circle data-guide-ring cx="50" cy="50" r="43"/></svg><b data-guide-percent>0%</b></div><div class="guide-progress-rows">${["Go for a run", "Focus on important work", "Learn something new"].map((name) => `<div class="guide-progress-row"><span>${icon("check")}</span><b class="demo-task-name">${t(name)}</b></div>`).join("")}</div></div><div class="guide-progress-days">${["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"].map((day, i) => `<span style="--delay:${i * 0.1}s"><i>${icon("check")}</i>${t(day)}</span>`).join("")}</div></div>`;
  return `<div class="guide-demo" data-demo="guide-system" aria-hidden="true"><div class="guide-demo-caption">${icon("pomodoro")}<span>${t("Daily focus")}</span><i></i></div><div class="guide-focus-session"><span>${icon("pomodoro")}</span><b data-guide-time>25:00</b><small>${t("Focus on important work")}</small></div><div class="guide-rhythm-stages">${["Plan", "Focus", "Reflect"].map((word, i) => `<span data-guide-stage="${i}">${icon(["today", "play", "weekly"][i])}${t(word)}</span>`).join("")}</div></div>`;
}

export function drawGuideDemo(
  scene,
  settled,
  { setText, formatTime, moveCursor },
) {
  const el = scene.element,
    seconds = (scene.elapsed % 14000) / 1000;
  if (el.dataset.demo === "guide-plan") {
    const name = t("Learn something new"),
      added = settled || seconds >= 5;
    setText(
      el.querySelector("[data-guide-typing]"),
      settled || added
        ? name
        : name.slice(0, Math.floor(Math.max(0, seconds - 0.4) * 9)),
    );
    el.classList.toggle("guide-plan-added", added);
    moveCursor(
      scene,
      el.querySelector("[data-guide-add]"),
      0,
      !settled && seconds >= 2 && seconds < 7,
      seconds >= 5 && seconds < 5.4,
    );
  } else if (el.dataset.demo === "guide-track") {
    const done = settled
      ? 2
      : Math.min(3, Math.floor(Math.max(0, seconds - 1) / 2.3));
    el.querySelectorAll(".guide-progress-row").forEach((row, i) =>
      row.classList.toggle("done", i < done),
    );
    setText(
      el.querySelector("[data-guide-percent]"),
      `${Math.round((done / 3) * 100)}%`,
    );
    el.querySelector("[data-guide-ring]").style.strokeDashoffset = String(
      270 * (1 - done / 3),
    );
    moveCursor(
      scene,
      el.querySelectorAll(".guide-progress-row > span")[Math.min(done, 2)],
      done,
      !settled && seconds < 10,
      done > 0 && (Math.max(0, seconds - 1) / 2.3) % 1 < 0.2,
    );
  } else {
    const step = settled ? 1 : seconds < 3 ? 0 : seconds < 10 ? 1 : 2;
    el.querySelectorAll("[data-guide-stage]").forEach((stage, i) =>
      stage.classList.toggle("selected", i === step),
    );
    setText(
      el.querySelector("[data-guide-time]"),
      formatTime(
        1500 - (!settled && seconds >= 3 ? Math.floor(seconds - 3) : 0),
      ),
    );
    el.classList.toggle(
      "guide-session-running",
      !settled && seconds >= 3 && seconds < 10,
    );
  }
}
